import { Card, CardContent } from '@/components/ui/card';
import { UserCog } from 'lucide-react';
import { VendedorMetrics } from '@/types/vendedores';
import { VendedorCard } from './VendedorCard';
import { useIsMobile } from '@/hooks/use-mobile';

interface VendedoresListProps {
  vendedores: VendedorMetrics[];
  loading: boolean;
  onVendedorClick: (vendedorId: string) => void;
}

export function VendedoresList({ vendedores, loading, onVendedorClick }: VendedoresListProps) {
  const isMobile = useIsMobile();

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {[...Array(6)].map((_, i) => (
          <Card key={i} className="animate-pulse">
            <CardContent className="p-6">
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="h-12 w-12 bg-muted rounded-full"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-muted rounded w-3/4"></div>
                    <div className="h-3 bg-muted rounded w-1/2"></div>
                  </div>
                </div>
                <div className="h-20 bg-muted rounded"></div>
                <div className="grid grid-cols-2 gap-2">
                  <div className="h-16 bg-muted rounded"></div>
                  <div className="h-16 bg-muted rounded"></div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (vendedores.length === 0) {
    return (
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-8 sm:py-12 px-4">
          <UserCog className="h-10 w-10 sm:h-12 sm:w-12 text-muted-foreground mb-4" />
          <h3 className="text-base sm:text-lg font-semibold mb-2 text-center">Nenhum vendedor encontrado</h3>
          <p className="text-sm sm:text-base text-muted-foreground text-center max-w-md">
            Não há vendedores cadastrados no sistema ou que correspondam aos filtros aplicados.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
      {vendedores.map((vendedor) => (
        <VendedorCard
          key={vendedor.vendedor_id}
          vendedor={vendedor}
          onClick={() => onVendedorClick(vendedor.vendedor_id)}
        />
      ))}
    </div>
  );
}

